import type { MfaEmailCodeSentResponseDto } from "@babackapp/private-api-client/types";
import type { MfaEmailCodeSent } from "../types";

/** Call when the answer arrives: the countdown runs from this moment. */
export function receiveMfaEmailCode(
	response: MfaEmailCodeSentResponseDto,
): MfaEmailCodeSent {
	return { ...response, receivedAt: Date.now() };
}
